import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import AppPromo from './AppPromo';
import styles from './AppPromoBanner.module.css';

/**
 * @param {object} props
 * @param {string=} props.className
 */
export default function AppPromoBanner({ className = '' }) {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <div className={styles.banner}>
        <StaticImage
          alt=""
          aria-hidden="true"
          src="../../assets/img/FridgeSceneBG.jpeg"
          className={styles.bgImg}
        />
        <StaticImage
          alt=""
          aria-hidden="true"
          src="../../assets/img/HandHoldingPhone.png"
          width={400}
          className={styles.phoneImg}
        />
      </div>
      <AppPromo className={styles.promo} />
    </div>
  );
}
